import { getMokaAreaAnalysis } from "@/utils/get-moka-area-analysis";
const getMokaAreaScore = gameState => getMokaAreaAnalysis(gameState).score;
export { getMokaAreaScore };